// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".active-button[data-v-b96bea82]{background-color:#f55028}.available-brands[data-v-b96bea82]{border-top:1px solid #e1e1e1;overflow-x:auto}.available-brands__wrapper[data-v-b96bea82]{width:-moz-max-content;width:max-content}[data-v-b96bea82]::-webkit-scrollbar{display:none}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
